export default function parseRequirements(requirements) {
  //convert array to values react select can read
  let returnValue = [];
  for (var i = 0; i < requirements.length; i++) {
    returnValue.push({
      value: requirements[i].id,
      label: requirements[i].name,
    });
  }
  return returnValue;
}
